// Mapas centrales de estado -> { etiqueta, color }. Regla aprendida del bug
// de la Fase 4: SIEMPRE con respaldo. Un valor no contemplado (o null
// mientras carga) degrada a "Desconocido" gris, nunca revienta la pantalla.
export const ESTADO_POR_DEFECTO = { etiqueta: 'Desconocido', color: 'gris' };

export const ESTADO_PRODUCTO = {
  DISPONIBLE: { etiqueta: 'Disponible', color: 'verde' },
  CUARENTENA: { etiqueta: 'Cuarentena', color: 'ambar' },
  RESERVADO: { etiqueta: 'Reservado', color: 'azul' },
  OBSOLETO: { etiqueta: 'Obsoleto', color: 'gris' },
};

export const ESTADO_SUSCRIPCION = {
  prueba: { etiqueta: 'Prueba', color: 'azul' },
  activa: { etiqueta: 'Activa', color: 'verde' },
  vencida: { etiqueta: 'Vencida', color: 'rojo' },
  cancelada: { etiqueta: 'Cancelada', color: 'gris' },
};

// Estado comercial de una empresa cliente, visto desde el panel de
// plataforma. 'cancelada' en gris y no en rojo a propósito: no es una
// alarma, es una cuenta cerrada cuyos datos se conservan.
export const ESTADO_CLIENTE = {
  activa: { etiqueta: 'Activa', color: 'verde' },
  suspendida: { etiqueta: 'Suspendida', color: 'rojo' },
  cancelada: { etiqueta: 'Cancelada', color: 'gris' },
};

// Interesados que llegan por el bot de Telegram (Fase 3 del bot).
//
// «nuevo» va en ÁMBAR y no en azul a propósito: es lo único de esta
// pantalla que reclama que alguien haga algo hoy. Un interesado nuevo que
// se queda sin contestar deja de ser un interesado.
//
// «se perdió» en gris y no en rojo: no es una avería, es algo que pasó.
// El rojo se reserva para lo que está mal, y pintar de rojo cada
// prospecto que no salió es como se deja de mirar el rojo.
//
// LOS CINCO SON LOS DE LA MIGRACION 200 (1 de septiembre de 2026). Los
// dos que se renombraron —`atendido` y `descartado`— SE QUEDAN ABAJO con
// su etiqueta vieja y no se borran: son las palabras que puede seguir
// habiendo en una pantalla abierta desde antes del despliegue, y sin
// ellas ese chip saldría en blanco. La base ya no las acepta; esto solo
// sabe pintarlas si aparecen.
export const ESTADO_INTERESADO = {
  nuevo: { etiqueta: 'Sin contestar', color: 'ambar' },
  contactado: { etiqueta: 'Ya le escribí', color: 'azul' },
  cotizado: { etiqueta: 'Ya le pasé precios', color: 'azul' },
  ganado: { etiqueta: 'Ganado', color: 'verde' },
  perdido: { etiqueta: 'Se perdió', color: 'gris' },
  atendido: { etiqueta: 'Contestado', color: 'azul' },
  descartado: { etiqueta: 'Descartado', color: 'gris' },
};

// LAS CLAVES SON LAS DE `estado_invitacion()` EN MINUSCULAS, y también
// las de la columna `estado`, que son otras. Conviven a propósito: la
// pantalla pinta el estado derivado —el que mira el reloj— y las claves
// viejas siguen aquí porque hay código que lee la columna directa.
//
// EL VERDE DE «ACEPTADA» ES UN HECHO COMPROBADO, no decoración: esa
// persona entró y tiene cuenta. Lo demás es ámbar —espera— o gris —ya no
// sirve—, nunca verde.
export const ESTADO_INVITACION = {
  pendiente: { etiqueta: 'Pendiente', color: 'ambar' },
  aceptada: { etiqueta: 'Aceptada', color: 'verde' },
  // Del estado derivado (Accesos Fase 1).
  caducada: { etiqueta: 'Se le pasó el plazo', color: 'gris' },
  revocada: { etiqueta: 'Retirada', color: 'gris' },
  // De la columna, que sigue existiendo.
  expirada: { etiqueta: 'Expirada', color: 'gris' },
  cancelada: { etiqueta: 'Cancelada', color: 'gris' },
};

// Solicitudes de movimiento sensible (cuatro ojos). PENDIENTE en ámbar
// porque es lo único que reclama acción de alguien.
export const ESTADO_SOLICITUD_MOV = {
  PENDIENTE: { etiqueta: 'Esperando', color: 'ambar' },
  APROBADO: { etiqueta: 'Autorizado', color: 'verde' },
  RECHAZADO: { etiqueta: 'Rechazado', color: 'rojo' },
  CANCELADO: { etiqueta: 'Retirado', color: 'gris' },
};

// Traslados entre sitios (migración 068). EN_CAMINO en ámbar porque es lo
// único que reclama la acción de alguien: hay mercancía esperando en un
// andén. RECIBIDO_CON_FALTANTES también, y no en rojo: no es un fallo, es
// mercancía que sigue contada en tránsito y que hay que ir a buscar.
export const ESTADO_TRASLADO = {
  EN_CAMINO: { etiqueta: 'En camino', color: 'ambar' },
  RECIBIDO: { etiqueta: 'Recibido', color: 'verde' },
  RECIBIDO_CON_FALTANTES: { etiqueta: 'Llegó incompleto', color: 'ambar' },
  CANCELADO: { etiqueta: 'Se dio la vuelta', color: 'gris' },
};

// Sesiones de conteo cíclico y sus renglones.
export const ESTADO_CONTEO = {
  ABIERTA: { etiqueta: 'En curso', color: 'azul' },
  CERRADA: { etiqueta: 'Cerrada', color: 'verde' },
  CANCELADA: { etiqueta: 'Cancelada', color: 'gris' },
};

// SIN_CONTAR en gris y no en rojo: no es un problema, es trabajo pendiente.
// FALTANTE sí es rojo — es la señal que este módulo existe para dar.
export const ESTADO_RENGLON = {
  SIN_CONTAR: { etiqueta: 'Sin contar', color: 'gris' },
  COINCIDE: { etiqueta: 'Cuadra', color: 'verde' },
  SOBRANTE: { etiqueta: 'Sobrante', color: 'ambar' },
  FALTANTE: { etiqueta: 'Faltante', color: 'rojo' },
};

// Gravedad de una anomalía. ALTA en rojo: intentar entrar donde no te toca
// o sacar el mismo producto cinco veces no es un descuido de proceso.
export const SEVERIDAD_ALERTA = {
  BAJA: { etiqueta: 'Baja', color: 'gris' },
  MEDIA: { etiqueta: 'Media', color: 'ambar' },
  ALTA: { etiqueta: 'Alta', color: 'rojo' },
};

export const ESTADO_PAGO = {
  pendiente: { etiqueta: 'Pendiente', color: 'ambar' },
  pagado: { etiqueta: 'Pagado', color: 'verde' },
  fallido: { etiqueta: 'Fallido', color: 'rojo' },
  cancelado: { etiqueta: 'Cancelado', color: 'gris' },
};

export const ESTADO_USUARIO = {
  activo: { etiqueta: 'Activo', color: 'verde' },
  suspendido: { etiqueta: 'Suspendido', color: 'ambar' },
  bloqueado: { etiqueta: 'Bloqueado', color: 'rojo' },
  baja: { etiqueta: 'Dado de baja', color: 'gris' },
};

// Deriva la clave de estado de un usuario a partir de sus banderas. El
// orden importa y va de lo más definitivo a lo más pasajero: una baja
// manda sobre una suspensión, y una suspensión sobre un bloqueo por
// intentos fallidos. Enseñar el motivo menos grave engañaría a quien mira.
export function estadoUsuario(u) {
  if (!u.activo) return 'baja';
  if (u.suspendido) return 'suspendido';
  if (u.bloqueado) return 'bloqueado';
  return 'activo';
}

export function infoEstado(mapa, clave) {
  return (mapa && mapa[clave]) || ESTADO_POR_DEFECTO;
}

// ---------------------------------------------------------------------
// CALIDAD · Fase 3
// ---------------------------------------------------------------------
// Los colores de la casa, sin excepción: verde=bien, ámbar=atención,
// rojo=problema (Doctrina 2, regla 10).
//
// CUARENTENA SE DICE «RETENIDO», y no es un capricho de traducción: en
// el sistema ya existe una UBICACIÓN de tipo cuarentena, que es un sitio
// físico. Llamar igual a las dos cosas hace que «está en cuarentena» no
// signifique nada — ¿el estado o el rack?
//
// CONDICIONAL va en ÁMBAR y no en verde: es material que salió con algo
// que anotar. Pintarlo de verde lo igualaría a lo que pasó limpio, que
// es justo la diferencia que a alguien le va a interesar dentro de un
// año.
export const ESTADO_CALIDAD_LOTE = {
  LIBERADO: { etiqueta: 'Liberado', color: 'verde' },
  CUARENTENA: { etiqueta: 'Retenido', color: 'ambar' },
  CONDICIONAL: { etiqueta: 'Liberado con observaciones', color: 'ambar' },
  RECHAZADO: { etiqueta: 'Rechazado', color: 'rojo' },
};

// BORRADOR en ámbar porque es lo único que reclama la acción de alguien:
// hay una inspección a medias que todavía no cuenta para nada.
export const ESTADO_INSPECCION = {
  BORRADOR: { etiqueta: 'Borrador', color: 'ambar' },
  FIRMADA: { etiqueta: 'Firmada', color: 'verde' },
};

export const RESULTADO_INSPECCION = {
  APROBADO: { etiqueta: 'Aprobado', color: 'verde' },
  CONDICIONAL: { etiqueta: 'Con observaciones', color: 'ambar' },
  RECHAZADO: { etiqueta: 'Rechazado', color: 'rojo' },
};

export const RESULTADO_MEDIDA = {
  OK: { etiqueta: 'Dentro', color: 'verde' },
  NOK: { etiqueta: 'Fuera', color: 'rojo' },
};

// ---------------------------------------------------------------------
// CALIDAD · Fase 4
// ---------------------------------------------------------------------
// ABIERTA en ámbar y no en rojo: una no conformidad recién abierta no es
// una alarma, es trabajo por hacer. El rojo se guarda para lo que de
// verdad va mal, que aquí es una acción correctiva vencida.
//
// CERRADA en gris y no en verde, y es deliberado. Verde diría «esto
// salió bien», y lo que dice es «esto ya se atendió». Un histórico de no
// conformidades cerradas en verde se lee como una planta sin problemas.
export const ESTADO_NC = {
  ABIERTA: { etiqueta: 'Abierta', color: 'ambar' },
  EN_ANALISIS: { etiqueta: 'En análisis', color: 'azul' },
  EN_ACCION: { etiqueta: 'En acción', color: 'azul' },
  EN_VERIFICACION: { etiqueta: 'En verificación', color: 'azul' },
  CERRADA: { etiqueta: 'Cerrada', color: 'gris' },
};

export const SEVERIDAD_NC = {
  ALTA: { etiqueta: 'Grave', color: 'rojo' },
  MEDIA: { etiqueta: 'Media', color: 'ambar' },
  BAJA: { etiqueta: 'Leve', color: 'gris' },
};

export const ESTADO_ACCION = {
  PENDIENTE: { etiqueta: 'Pendiente', color: 'ambar' },
  HECHA: { etiqueta: 'Hecha', color: 'verde' },
  CANCELADA: { etiqueta: 'Cancelada', color: 'gris' },
};

// ---------------------------------------------------------------------
// CALIDAD · Fase 5
// ---------------------------------------------------------------------
// SIN_CALIBRAR va en ROJO igual que VENCIDO, y no en gris. No es lo
// mismo filosóficamente —uno venció, el otro nunca se calibró— pero en
// la práctica significan exactamente lo mismo: no se puede demostrar que
// mida bien. Pintarlo de gris lo dejaría pasando por «pendiente de
// trámite» cuando es «no lo uses».
export const VIGENCIA_INSTRUMENTO = {
  VIGENTE: { etiqueta: 'Vigente', color: 'verde' },
  POR_VENCER: { etiqueta: 'Por vencer', color: 'ambar' },
  VENCIDO: { etiqueta: 'Vencido', color: 'rojo' },
  SIN_CALIBRAR: { etiqueta: 'Sin calibrar', color: 'rojo' },
};

export const ESTADO_INSTRUMENTO = {
  ACTIVO: { etiqueta: 'En uso', color: 'verde' },
  FUERA_DE_SERVICIO: { etiqueta: 'Fuera de servicio', color: 'ambar' },
  BAJA: { etiqueta: 'De baja', color: 'gris' },
};

export const RESULTADO_CALIBRACION = {
  CONFORME: { etiqueta: 'Pasó', color: 'verde' },
  AJUSTADO: { etiqueta: 'Pasó, ajustado', color: 'ambar' },
  NO_CONFORME: { etiqueta: 'No pasó', color: 'rojo' },
};

// ---------------------------------------------------------------------
// TERMINAL DE CONTEO · T-1
// ---------------------------------------------------------------------
// VITRINA VA EN ÁMBAR Y NO EN GRIS. Gris diría «esto no importa», y sí
// importa: una terminal en vitrina está encendida, está enseñando la
// repisa, y NO puede mover nada. Es exactamente «atención»: si alguien
// esperaba que estuviera contando, no lo está.
//
// El texto de TRABAJANDO lo pone la pantalla con el nombre de quien está
// delante — «Juan está aquí» dice más que «Trabajando».
export const ESTADO_TERMINAL = {
  TRABAJANDO: { etiqueta: 'Alguien está usándola', color: 'verde' },
  VITRINA: { etiqueta: 'Nadie vinculado', color: 'ambar' },
  RETIRADA: { etiqueta: 'Retirada', color: 'rojo' },
};

// ---------------------------------------------------------------------
// LA ESTACIÓN EN VIVO · Anexo B, B-3
// ---------------------------------------------------------------------
// SIN_TERMINAL VA EN GRIS Y NO EN ROJO. No es un problema: la inmensa
// mayoría de las repisas de un almacén no tienen ni tendrán terminal, y
// pintarlas de rojo sería una alarma permanente por no haber comprado un
// aparato.
export const ESTADO_ESTACION = {
  TRABAJANDO: { etiqueta: 'Alguien está trabajando', color: 'verde' },
  VITRINA: { etiqueta: 'Nadie vinculado', color: 'ambar' },
  RETIRADA: { etiqueta: 'Terminal retirada', color: 'rojo' },
  SIN_TERMINAL: { etiqueta: 'Sin terminal', color: 'gris' },
};

// El motivo que se le enseña a una persona cuando una LISTA no cargó.
//
// T-05 · «Estados que mienten». Un fallo llega en dos formas y NO se dicen
// igual:
//   · El servidor contestó con un rechazo. Trae `status` y un mensaje ya
//     en español (lo arma `procesar` en `api.js`): se enseña tal cual.
//   · No se llegó al servidor (red caída, servidor reiniciando). El
//     navegador lanza un error CRUDO Y EN INGLÉS —«Failed to fetch»,
//     «Load failed», «NetworkError»— y ese texto NO se le enseña a nadie:
//     se devuelve `null` y `ErrorConReintento` pone la explicación de red
//     en español. Enseñar el inglés convertía un tropiezo de red en una
//     pantalla que parecía vacía con un error indescifrable al pie.
const RED_EN_INGLES = /failed to fetch|networkerror|load failed|network request failed|the internet connection appears to be offline/i;
export function motivoDeError(error) {
  if (!error) return null;
  const status = typeof error === 'object' ? error.status : null;
  const texto = typeof error === 'string' ? error : (error?.message || '');
  // Con `status` es una respuesta del servidor: su mensaje ya está en
  // español y dice qué revisar.
  if (status) return texto || null;
  // Sin `status` no se llegó al servidor. Si el texto es el crudo del
  // navegador (inglés), no se enseña: manda la explicación de red.
  if (!texto || RED_EN_INGLES.test(texto)) return null;
  return texto;
}
